/**
 * 报名 Step2 成员职能选项（value 存入数据库，labelKey 用于 $T 展示）
 */
export const MEMBER_FUNCTION_OPTIONS = [
  { value: 'Gymnast', labelKey: '成员职能体操运动员' },
  { value: 'Heads of delegation', labelKey: '成员职能代表团团长' },
  { value: 'NF President and NF President guest', labelKey: '成员职能联合会主席及嘉宾' },
  { value: 'NF President and NF President guest VIP', labelKey: '成员职能联合会主席及嘉宾VIP' },
  { value: 'Medical doctor', labelKey: '成员职能医生' },
  { value: 'Mental Health Professional', labelKey: '成员职能心理健康专业人员' },
  { value: 'Guest', labelKey: '成员职能嘉宾' },
  { value: 'Guest VIP', labelKey: '成员职能嘉宾VIP' },
  { value: 'Team manager (TRA)', labelKey: '成员职能蹦床队经理' },
  { value: 'Coach (TRA)', labelKey: '成员职能蹦床教练' },
  { value: 'Paramedical staff (TRA)', labelKey: '成员职能蹦床医务保障' },
  { value: 'TRA Senior Judge', labelKey: '成员职能蹦床高级裁判' },
  { value: 'Team manager (TUM)', labelKey: '成员职能技巧队经理' },
  { value: 'Coach (TUM)', labelKey: '成员职能技巧教练' },
  { value: 'Paramedical staff (TUM)', labelKey: '成员职能技巧医务保障' },
  { value: 'TUM Senior Judge', labelKey: '成员职能技巧高级裁判' },
  { value: 'Team manager (DMT)', labelKey: '成员职能双杠队经理' },
  { value: 'Coach (DMT)', labelKey: '成员职能双杠教练' },
  { value: 'Paramedical staff (DMT)', labelKey: '成员职能双杠医务保障' },
  { value: 'DMT Senior Judge', labelKey: '成员职能双杠高级裁判' },
  // 兼容旧数据
  { value: 'Coach', labelKey: '教练' },
  { value: 'Judge', labelKey: '裁判' },
  { value: 'Team Manager', labelKey: '队伍经理' },
];



// WEBPACK FOOTER //
// ./src/utils/memberFunctionOptions.js